import React, { Component } from "react";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import Checkbox from "@material-ui/core/Checkbox";

class PromoteStudentBody extends Component {
  handleSingleClick = (e, id) => {
    const { students } = this.props;
    const selectedIndex = students.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(students, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(students.slice(1));
    } else if (selectedIndex === students.length - 1) {
      newSelected = newSelected.concat(students.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        students.slice(0, selectedIndex),
        students.slice(selectedIndex + 1)
      );
    }
    this.props.handleClick(newSelected);
  };

  render() {
    const { data, index, students } = this.props;
    return (
      <TableRow>
        <TableCell align="center">
          <Checkbox
            onClick={(e) => this.handleSingleClick(e, data._id)}
            checked={students.includes(data._id) ? true : false}
          />
        </TableCell>
        <TableCell align="center">{index + 1}</TableCell>
        <TableCell align="center">
          {data.firstName} {data.middleName} {data.lastName}
        </TableCell>
        <TableCell align="center">{data.studentClass}</TableCell>
        <TableCell align="center">
          {data.faculty ? data.faculty : "N/A"}
        </TableCell>
        <TableCell align="center">{data.group ? data.group : "N/A"}</TableCell>
        <TableCell align="center">{data.section}</TableCell>
      </TableRow>
    );
  }
}

export default PromoteStudentBody;
